import { IonCol, IonItemOption, IonItemOptions, IonLabel } from "@ionic/react";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { EventPriority, Events, EventType } from "../Event/types";
import FilterList, { isFilterActive } from "../FilterList/FilterList";
import { EventCategoryIcon } from '../Icons';

import
{
    SystemStatusIcon,
    SystemTypeIcon
} from '../Icons';

import List from "../List/List";
import Sidebar from "../Navigation/Sidebar/System";

import { System, SystemStatus, SystemType } from "@ews/react-data";
import { useL10n } from "@ews/react-localization-context";
import { RTMCategory } from "@ews/zlt-events";
import type { FilterProps } from "../../pages/System";
import { globalDebounceTime, Locale } from "../../setup/locale";
import Checkbox from "../Checkbox/Wrapper";
import { FilterState } from "../FilterList/types";
import { defaultPageRange } from "../List/Pagination/pagerange";
import { HeaderOption } from "../List/types";
import { useMyNotifySystems } from "../Login/LoginProvider";
import { useNamedRoutes } from "../NamedRoutes";
import { resizeMenuPopoverContent } from "../Navigation/Sidebar/Sidebar";
import { usePersistentState } from "../Persistence";
import { useMySystems } from "../ReactData/system";
import { useIsMobile } from "../Responsive";
import SettingsTextInput from "../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { Filter } from "./Reports/types/reportTypes";
import systemStyle from './SystemList.module.scss';
import SystemMap from "./SystemMap";

const header: HeaderOption<Locale, System>[] = [
    {
        title: '[SID_MNU_TAB_INFO_SCR]',//'TD_ZENTRALENNAME',
        key: 'name',
        className: systemStyle.systemname,
        both: true,
    },
    // {
    //     title: 'COM_MODULES_MENU_ITEM_ALIAS',
    //     key: 'alias',
    //     breakpoint: 1600, up: true,
    // },
    {
        title: 'COM_FACPMANAGEMENT_LOGS_MAIL_ANLAGENID',
        key: 'systemNumber',
        className: systemStyle.systemNumber,
        both: true,
    },
    {
        title: '[SID_SYSTEM_KEY]',
        key: 'systemKey',
        className: systemStyle.systemKey,

        option: {
            key: 'systemType',
            choiceList: Object.keys(SystemType).sort().map(k => [k, <SystemTypeIcon width="50px" height="50px" type={SystemType[k as keyof typeof SystemType]} />])
        },
        both: true,
    },
    {
        title: 'COM_FACPMANAGEMENT_FACP_OPERATIONS_SHORT',
        key: 'inputDevices',
        className: systemStyle.inputDevices,
        breakpoint: 992, up: true,
    },
    {
        title: 'COM_FACPMANAGEMENT_FACP_ACTUATIONS_SHORT',
        key: 'outputDevices',
        className: systemStyle.outputDevices,
        breakpoint: 1012, up: true,
    },
    {
        title: 'COM_FACPMANAGEMENT_CUSTOMER_FIELD_CUSTOMER_NUMBER',
        key: 'customerNumber',
        className: systemStyle.customerNumber,
        breakpoint: 1122, up: true,
        subEntity: 'customer.customerNumber',
        option: { noSort: true },
    },
    {
        title: 'COM_FACPMANAGEMENT_CUSTOMERS_NAME',
        key: 'customerName',
        className: systemStyle.customerName,
        breakpoint: 1322, up: true,
        subEntity: 'customer.name',
        option: { noSort: true },
    },

    {
        title: '[SID_MNU_HK_ONE_EVENT]',
        key: 'priority',
        className: systemStyle.eventPriority,
        both: true,
        child: (system: System) => <div className={systemStyle.eventIcons || ""}>
            <SystemStatusIcon status={system.status!} />
            {EventPriority.map((e) =>
            {
                return (system.eventStatus! & Events[e]) ?
                    <EventCategoryIcon key={`event-${e}`} category={e} />
                    :
                    <React.Fragment key={`event-fragment-${e}`} />;
            })}
        </div>,
    },
];

type PersistentFilter = Filter<ListFilter> & FilterState;
const ignoreKeys: (keyof PersistentFilter)[] = ["pageSize", "isFilterOpen", "_timestamp", "page", "pageSize", "sortCriteria", "sortOrder"];
const onMenu = (id: string, onMenuToggle: () => void) => <div style={{ height: "430px", }}><Sidebar onMenuToggle={onMenuToggle} routeParams={{ id }} /></div>;

const eventKindTypeList: number[] = [1, 2, 4, 16];
const sumEventKindType = [...eventKindTypeList].reduce((total, current) => total | current);

export type ListFilter = {
    name?: string;
    systemType?: string;
    "customer.customerNumber"?: string;
    "customer.name"?: string;
    tree?: string,
    systemNumber?: string;
    eventStatus?: number;
    status?: string;
    systemKey?: string;
    _timestamp?: number;
};

type SystemStatus_ = typeof SystemStatus[keyof typeof SystemStatus];
type SystemType_ = keyof typeof SystemType;

const systemStatusAvailable: SystemStatus_[] = Object.keys(SystemStatus).filter(status => !isNaN(Number(status))) as unknown[] as SystemStatus_[];
const systemTypeAvailable: SystemType[] = Object.values(SystemType).sort();


export const standardFilter: PersistentFilter = {
    sortCriteria: "priority",
    sortOrder: "DESC",
    systemType: systemTypeAvailable.sort().join(","),

    status: systemStatusAvailable.sort().join(","),
    pageSize: defaultPageRange
};



const FilterListMainComponent: React.FC<{
    name: PersistentFilter["name"],
    systemNumber: PersistentFilter["systemNumber"],
    customerName: PersistentFilter["customer.name"],
    customerNumber: PersistentFilter["customer.customerNumber"],
    systemKey: PersistentFilter["systemKey"],
    setState: React.Dispatch<React.SetStateAction<PersistentFilter>>;
}> = React.memo(({
    name,
    systemNumber,
    customerName,
    customerNumber,
    systemKey,

    setState }) =>
{
    return <>
        <IonCol>
            <SettingsTextInput
                id="systemName"
                text={"COM_FACPMANAGEMENT_HISTORYSYSTEMS_ANLAGEN_NAME"}
                debounce={globalDebounceTime}
                value={name}

                onChange={(data) =>
                {
                    setState((prev) =>
                    {
                        const newState = { ...prev };

                        if (data.length) newState.name = data;
                        else delete newState.name;
                        return newState;
                    });
                }}
            />
        </IonCol>
        <IonCol>

            <SettingsTextInput
                text={"COM_FACPMANAGEMENT_LOGS_MAIL_ANLAGENID"}
                debounce={globalDebounceTime}
                value={systemNumber}
                onChange={(systemNumber) =>
                {


                    setState((prev) =>
                    {
                        const newState = { ...prev };

                        if (systemNumber.length) newState.systemNumber = systemNumber;
                        else delete newState.systemNumber;
                        return newState;
                    });
                }} />
        </IonCol>
        <IonCol>

            <SettingsTextInput
                text={"[SID_SYSTEM_KEY]"}
                debounce={globalDebounceTime}
                value={systemKey}
                onChange={(systemKey) =>
                {


                    setState((prev) =>
                    {
                        const newState = { ...prev };

                        if (systemKey.length) newState.systemKey = systemKey;
                        else delete newState.systemKey;
                        return newState;
                    });
                }} />
        </IonCol>
        <IonCol>
            <SettingsTextInput
                debounce={globalDebounceTime}
                text={"COM_FACPMANAGEMENT_CUSTOMERS_NAME"}
                value={customerName}
                onChange={(customerName) =>
                {


                    setState((prev) =>
                    {
                        const newState = { ...prev };

                        if (customerName.length) newState["customer.name"] = customerName;
                        else delete newState["customer.name"];
                        return newState;
                    });
                }}
            />
        </IonCol>
        <IonCol>
            <SettingsTextInput
                debounce={globalDebounceTime}
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_CUSTOMER_NUMBER"}
                value={customerNumber}
                onChange={(customerNumber) =>
                {


                    setState((prev) =>
                    {
                        const newState = { ...prev };

                        if (customerNumber.length) newState["customer.customerNumber"] = customerNumber;
                        else delete newState["customer.customerNumber"];
                        return newState;
                    });
                }}
            />
        </IonCol>
    </>;
});

const DetailFilterComponent: React.FC<{
    currentEventStatus: PersistentFilter["eventStatus"],
    setState: React.Dispatch<React.SetStateAction<PersistentFilter>>;
    selectedStatus: SystemStatus_[],
    setSelectedStatus: React.Dispatch<React.SetStateAction<SystemStatus_[]>>,
    selectedType: string[],
    setSelectedType?: React.Dispatch<React.SetStateAction<("BC216" | "BC600" | "BC08")[]>>;
    handleSelectEvent: (eventKindtype: number,
        checked: boolean) => void;
}> =
    React.memo(({
        selectedStatus,
        setSelectedStatus,
        selectedType,
        setSelectedType,
        currentEventStatus,
        setState,
        handleSelectEvent
    }) =>
    {
        const { translate: t } = useL10n();
        return <> <IonCol>
            <div>
                <IonLabel>{t("[SID_KIND]")}</IonLabel>
                <div
                    className={systemStyle.filterTypesContainer}
                >
                    {systemTypeAvailable.map((currentType, index) =>
                    {
                        return <div key={currentType + index} className={systemStyle.iconContainer}>

                            <Checkbox
                                checked={selectedType.indexOf(currentType as any) !== -1 ? true : false}

                                position={
                                    {
                                        top: -10,
                                        right: -10
                                    }
                                }
                                onClick={(checked) =>
                                {
                                    let type = selectedType;

                                    const typeKey = currentType as SystemType_;

                                    if (checked && type.indexOf(typeKey) === -1) {
                                        type.push(typeKey);
                                    } else {
                                        type = type.filter(t => t !== typeKey);
                                    }

                                    setState((prev) =>
                                    {
                                        const newState = { ...prev };

                                        if (type.length) {
                                            newState.systemType = type.sort().join(",");
                                        } else {
                                            delete newState.systemType;
                                        }
                                        return newState;
                                    });
                                }}>

                                <SystemTypeIcon type={currentType}></SystemTypeIcon>
                                <IonLabel>{currentType}</IonLabel>
                            </Checkbox>

                        </div>;
                    })}
                </div>
            </div>
        </IonCol>
            <IonCol>
                <div>
                    <IonLabel>{t("[REACT_FC_STATUS]")}</IonLabel>
                    <div
                        className={systemStyle.filterStatusContainer}
                    >
                        {systemStatusAvailable.map((currentStatus, index) =>
                        {
                            return <div key={currentStatus + index} className={systemStyle.iconContainer}>
                                <Checkbox
                                    position={{
                                        top: -10,
                                        right: -10
                                    }}
                                    checked={selectedStatus.indexOf(currentStatus as SystemStatus_) !== -1 ? true : false}
                                    onClick={(checked) =>
                                    {
                                        let status = selectedStatus;

                                        const statusKey = currentStatus as SystemStatus_;

                                        if (checked && status.indexOf(statusKey) === -1) {
                                            status.push(statusKey);
                                        } else {
                                            status = status.filter(st => st !== statusKey);
                                        }

                                        setSelectedStatus(status);
                                        setState((prev) =>
                                        {
                                            const newState = { ...prev };

                                            if (status.length) {
                                                const statusValues = status//.map((key) => SystemStatus[key])
                                                    .sort();
                                                newState.status = statusValues.join(",");
                                            } else {
                                                delete newState.status;
                                            }
                                            return newState;
                                        });
                                    }}>
                                    <SystemStatusIcon className={systemStyle.iconSize} status={currentStatus} />
                                </Checkbox>
                            </div>;
                        })}
                    </div>
                </div>

            </IonCol>
            <IonCol>
                <div>
                    <IonLabel>{t("[SID_MNU_HK_ONE_EVENT]")}</IonLabel>
                    <div
                        className={systemStyle.filterStatusContainer}
                    >
                        {eventKindTypeList.map((eventKindType, index) =>
                        {
                            let isChecked = false;
                            if (eventKindType !== sumEventKindType && currentEventStatus) {
                                let byte = eventKindType & currentEventStatus;
                                isChecked = Boolean(byte);
                            }
                            else {
                                isChecked = currentEventStatus === sumEventKindType;
                            }

                            return <div key={eventKindType + index} className={systemStyle.iconContainer}>
                                <Checkbox
                                    position={{
                                        top: -10,
                                        right: -10
                                    }}
                                    checked={isChecked}
                                    onClick={(checked) => handleSelectEvent(eventKindType, checked)}
                                >
                                    <EventCategoryIcon className={systemStyle.iconSize} key={`event-${eventKindType}`} category={`${RTMCategory[eventKindType]}` as EventType} />
                                </Checkbox>

                            </div>;
                        })}
                    </div>
                </div>
            </IonCol>
        </>;
    },);

const SystemList: React.FC<{

    customerTree?: string,
    type: "list" | "map";
} & FilterProps> = ({
    customerTree,
    type,
    filter,
    onIsOpen,
    onFilterActive
}) =>
    {
        const { translate: t, getLocale } = useL10n();
        const locale = getLocale();

        const { generate } = useNamedRoutes();
        const refreshOnNotifySystem = useMyNotifySystems();

        const mobileView = useIsMobile();

        const sortCriteria = useRef<{
            key: string;
            direction: "ASC" | "DESC";
        } | undefined>(undefined);

        const [selectedStatus, setSelectedStatus] = useState<SystemStatus_[]>(standardFilter.status!.split(",") as unknown as SystemStatus_[] || []);
        //const [selectedType, setSelectedType] = useState<SystemType_[]>(standardFilter.systemType!.split(",") as SystemType_[]);

        const _standartFilter = useMemo(() => ({ ...standardFilter, _timestamp: refreshOnNotifySystem.timestamp } as Filter<ListFilter>), [refreshOnNotifySystem?.timestamp]);
        const [currentState, setState] = usePersistentState<PersistentFilter>('systems:filter', _standartFilter);

        if (customerTree) {
            currentState.tree = customerTree;
        } else {
            delete currentState.tree;
        }

        const result = useMySystems(currentState, 0);

        const onPageChange = useCallback((page: PersistentFilter["page"]) => { setState((prev) => ({ ...prev, page })); }, [setState]);
        const onSortChange = useCallback((sortCriteria: PersistentFilter["sortCriteria"], sortOrder: PersistentFilter["sortOrder"]) => setState((prev) => ({ ...prev, sortCriteria, sortOrder })), [setState]);
        const onPageSizeChange = useCallback((pageSize: PersistentFilter["pageSize"]) => setState((prev) => ({ ...prev, pageSize })), [setState]);
        const onReloadChange = useCallback(() => setState((prev) => ({ ...prev })), [setState]);

        const onIsFilterOpen = useCallback((state: boolean) => { onIsOpen && onIsOpen(state, "main"); }, [onIsOpen]);
        const onIsDetailFilterOpen = useCallback((isDetailOpen: boolean) => onIsOpen && onIsOpen(isDetailOpen, "detail"), [onIsOpen]);
        const onResetFilter = useCallback(() => setState(() => standardFilter), [setState]);

        const isFilterChanged = isFilterActive<PersistentFilter>(currentState, standardFilter, ignoreKeys);

        useEffect(() =>
        {
            if (filter?.isFilterActive !== isFilterChanged) {
                onFilterActive && onFilterActive(isFilterChanged);
            }
        }, [isFilterChanged, filter, onFilterActive]);

        const rows = useMemo(() =>
        {
            if (!result) {
                console.error("SystemList result is falsy!");
            }
            if (!result?.results) {
                console.error("SystemList result?.results is falsy!");
            }

            return result.results.map((system) =>
            {
                if (system.filterOnClient) {
                    (system as any).className = systemStyle.disabled;
                } else {
                    (system as any).link = mobileView ?
                        generate("system:events", { page: "0", id: system.id }) :
                        generate("system", { id: system.id });
                }
                return system;
            });
        }, [locale, generate, result.results]);

        const handleSelectEvent = useCallback((eventKindtype: number, checked: boolean) =>
        {
            setState((prev) =>
            {
                const selectedEvent = currentState.eventStatus ? currentState.eventStatus : 0b00;
                const newState = { ...prev };

                eventKindtype = checked ? eventKindtype | selectedEvent : eventKindtype ^ selectedEvent;

                if (eventKindtype === 0) delete newState!.eventStatus;
                else newState.eventStatus = eventKindtype;
                return newState;
            });
        }, [currentState.eventStatus, setState]);



        useEffect(() =>
        {
            setState((current) =>
            {
                return refreshOnNotifySystem.timestamp !== current._timestamp ? { ...current, _timestamp: refreshOnNotifySystem.timestamp } : current;
            });

        }, [refreshOnNotifySystem, setState]);

        useEffect(() =>
        {
            sortCriteria.current =
                currentState.sortCriteria ? {
                    key: currentState.sortCriteria,
                    direction: currentState.sortOrder || "ASC"
                } : undefined;

        }, [currentState.sortCriteria, currentState.sortOrder]);


        const _DetailListComponente = useMemo(() => <DetailFilterComponent
            currentEventStatus={currentState.eventStatus}
            setState={setState}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            selectedType={currentState.systemType?.split(",") || []}
            //setSelectedType={setSelectedType}
            handleSelectEvent={handleSelectEvent} />,
            [currentState.eventStatus, handleSelectEvent, selectedStatus, currentState.systemType, setState]);




        const _FilterListComponent = useMemo(() =>
        {
            return <FilterListMainComponent
                setState={setState}
                name={currentState.name}
                systemNumber={currentState.systemNumber}
                customerName={currentState["customer.name"]}
                customerNumber={currentState["customer.customerNumber"]}
                systemKey={currentState.systemKey} />;
        }, [
            // it need to be like this because if you set only currentState it will rebuild event page or pageSize changes
            currentState["customer.customerNumber"],
            currentState["customer.name"],
            currentState.systemKey,
            currentState.systemNumber,
            currentState.name, setState]);

        return <div className={`${systemStyle.container}`}>
            {<FilterList
                isOpen={filter?.isFilterOpen || false}
                isDetailsOpen={filter?.isDetailOpen || false}
                onIsOpen={onIsFilterOpen}
                onDetailOpen={onIsDetailFilterOpen}
                onReset={onResetFilter}
                noPrint
                details={_DetailListComponente}
            >
                {_FilterListComponent}
            </FilterList >}


            {type === "list" ?
                <List
                    data-testid="list"
                    rows={rows}
                    sort={sortCriteria.current}
                    rowClass={systemStyle.row}
                    pageSize={result.pageSize}
                    onSort={onSortChange}
                    onPageChange={onPageChange}
                    onPageSize={onPageSizeChange}
                    onReload={onReloadChange}
                    currentPage={result.currentPage}
                    numberOfPages={result.totalCountOfPages}
                    //onPopupResize={resizeMenuPopoverContent}
                    /* maxHeight={mobileView ? "86vh" : "45vh"} */

                    onMenu={onMenu}
                    sliderChildren={
                        mobileView ?
                            <IonItemOptions side="start">
                                <IonItemOption color="success">{t("[SID_OPER_TEST_ACTIVATE]")}</IonItemOption>
                            </IonItemOptions>
                            :
                            null
                    }
                    headers={header}
                />
                : <SystemMap systems={result.results}></SystemMap>
            }
        </div>;
    };

export default SystemList;
